import { format } from "date-fns";
import Lottie from "lottie-react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Col, Input, InputGroup, Row } from "reactstrap";
import { Btn, LI, UL } from "../../AbstractElements";
import useIsMobile from "../../Hooks/useIsMobile";
import { useAuth } from "../../_helper/Auth/AuthProvider";
import { useComment } from "../../_helper/Comments/CommentProvider";
import { useFileUpload } from "../../_helper/FileUpload/FileUploadProvider";
import { useReport } from "../../_helper/Reports/ReportProvider";
import * as sending from "../../assets/images/lottie/sending.json";
import noComment from "../../assets/images/nocomment.png";

const Chat = ({ data }) => {
  const isMobile = useIsMobile();
  const { theme, user, authToken } = useAuth();
  const { getAllFiles } = useFileUpload();
  const { comments } = useReport();
  const { t } = useTranslation();
  const { isSending, addComment } = useComment();
  const [currentDateTime, setCurrentDateTime] = useState("");
  const [messageInput, setMessageInput] = useState("");

  //for api connection
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const backendPort = process.env.REACT_APP_BACKEND_PORT;
  let apiUrl = `${backendUrl}`;
  if (backendPort) {
    apiUrl += `:${backendPort}`;
  }

  const ticketId = data?._id;

  const handleMessageChange = (message) => {
    setMessageInput(message);
  };

  useEffect(() => {
    //get all files
    getAllFiles({
      uuid: ticketId,
      workspace: "INFLOW",
    });

    const getCurrentDateTime = () => {
      const currentDate = new Date();
      const formattedDateTime = format(
        currentDate,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      );
      setCurrentDateTime(formattedDateTime);
    };
    getCurrentDateTime();
    const interval = setInterval(getCurrentDateTime, 1000); // Update current date and time every second
    return () => clearInterval(interval);
  }, []);

  const CommentData = {
    data: {
      ownerId: data?._id, // ticketID
      parentId: data?.chatRoomThema[0]?._id, // Chat ROOM ID
      title: "allgemein",
      text: messageInput,
      createdByLdap: "",
      createdOnDate: currentDateTime,
      changedOnDate: currentDateTime,
      state: 0,
    },
  };

  const submitCommentForm = () => {
    if (messageInput === "") {
      toast.warning("Please type a message...", {
        autoClose: 1000,
      });
    } else {
      setMessageInput("");
      addComment(CommentData);
    }
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      submitCommentForm();
    }
  };

  return (
    <div className="chat">
      {comments.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "40px 0",
          }}
        >
          <img src={noComment} width={150} alt="no comments" />
        </div>
      ) : (
        <div
          className="chat-history chat-msg-box custom-scrollbar p-3"
          style={{
            background: theme === "dark-only" ? "#333846" : "#f5f6fa",
            borderRadius: 5,
            marginBottom: 10,
            height: 250,
            maxHeight: "500px",
            overflowY: "auto",
          }}
        >
          <UL>
            {comments?.map((item, index) => (
              <LI
                attrLI={{
                  className: "clearfix border-0 mb-2",
                }}
              >
                <div
                  className="p-3"
                  style={{
                    background:
                      item.createdByLdap === user.username
                        ? "#4688ff"
                        : theme === "dark-only"
                        ? "#262932"
                        : "#dcdcde",
                    color:
                      item.createdByLdap === user.username &&
                      theme === "dark-only"
                        ? "#262932"
                        : item.createdByLdap === user.username
                        ? "#fff"
                        : item.createdByLdap !== user.username &&
                          theme === "dark-only"
                        ? "#656571"
                        : "",
                    borderRadius: 10,
                    borderBottomRightRadius:
                      item.createdByLdap === user.username ? "0" : "10px",
                    borderBottomLeftRadius:
                      item.createdByLdap !== user.username ? "0" : "10px",
                    minWidth: 300,
                    display: "inline-block", // Ensures the width adjusts automatically
                    float:
                      item.createdByLdap === user.username ? "right" : "left",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ fontSize: 12, fontWeight: "400" }}>
                      {item?.createdByLdap} -{" "}
                      {format(
                        new Date(item?.changedOnDate),
                        "dd.MM.yyyy hh:mm a"
                      )}
                    </p>
                  </div>
                  {item.text}
                </div>
              </LI>
            ))}
          </UL>
        </div>
      )}

      {/* SEND BUTTON */}
      <Row>
        {isSending ? (
          <Col
            xl="12"
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 30,
            }}
          >
            <div style={{ width: 100, height: 50 }}>
              <Lottie animationData={sending} />
            </div>
          </Col>
        ) : (
          <Col xl="12" className="">
            <InputGroup>
              {/* <Input
                type="text"
                className="form-control input-txt-bx"
                placeholder={t("Type a message here...")}
                value={messageInput}
                required
                onChange={(e) => handleMessageChange(e.target.value)}
                onKeyPress={handleKeyPress}
              /> */}
              <Input
                type="text"
                className={`form-control input-txt-bx ${
                  theme === "dark-only"
                    ? "input-placeholder-dark"
                    : "input-placeholder-light"
                }`}
                placeholder={t("Type a message here...")}
                value={messageInput}
                required
                onChange={(e) => handleMessageChange(e.target.value)}
                onKeyPress={handleKeyPress}
                style={{
                  backgroundColor: theme === "dark-only" ? "#262932" : "", // Background color for dark/light mode
                  // color: theme === 'dark-only' ? "#ffffff" : "#000000", // Text color for dark/light mode
                  // border: theme === 'dark-only' ? "1px solid #fff" : "1px solid #ccc", // Border color
                  // borderRadius: "10px", // Optional: rounded corners
                }}
              />

              <Btn
                attrBtn={{
                  onClick: (e) => submitCommentForm(),
                  color: "primary",
                }}
              >
                <i class="fa fa-send" style={{ fontSize: 24 }}></i>
              </Btn>
            </InputGroup>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default Chat;
